import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "modals" }, null, -1)

import AdminLayout from "@/views/layout/AdminLayout.vue";
import AnonymousLayout from "@/views/layout/AnonymousLayout.vue";
import {computed} from 'vue';
import {useRouter} from "vue-router";
import {isDef} from "@/utils/general-utils";
import {useAuthStore} from "@/store/pinia/authStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

const layout = computed(() => {
  const authStore = useAuthStore();
  const routeLayout = router.currentRoute.value.meta.layout as { asAdmin: string; default: string };

  if (!isDef(routeLayout?.default)) {
    return AnonymousLayout;
  }

  if (isDef(routeLayout.asAdmin) && authStore.isAnyAdmin) {
    return getLayoutComponent(routeLayout.asAdmin);
  }

  return getLayoutComponent(routeLayout.default);
});

function getLayoutComponent(layout: string) {
  return layout === 'full' ? AdminLayout : AnonymousLayout;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    _hoisted_1
  ], 64))
}
}

})